import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a1 1 0 0 1 1 1v4h3a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-3v4a1 1 0 0 1 -2 0v-4h-3a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h3v-4a1 1 0 0 1 1 -1","key":"svg-0"}]]

const IconLayoutAlignCenterFilled = createReactComponent('filled', 'layout-align-center-filled', 'LayoutAlignCenterFilled', __iconNode);

export default IconLayoutAlignCenterFilled;